// Actions
export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS';
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR';
export const GET_REPORTS = 'GET_REPORTS';
export const PROPOSAL_BY_SELLER = 'PROPOSAL_BY_SELLER';
export const SEARCH_ASSOCIATES = 'SEARCH_ASSOCIATES';
